import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-5" }
const _hoisted_2 = { class: "bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl p-4" }
const _hoisted_3 = { class: "flex items-start gap-3" }
const _hoisted_4 = { class: "bg-gray-50 dark:bg-gray-700/50 rounded-xl p-4" }
const _hoisted_5 = { class: "text-sm text-gray-700 dark:text-gray-300 space-y-1 list-disc pl-5" }
const _hoisted_6 = {
  key: 0,
  class: "p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl"
}
const _hoisted_7 = { class: "text-sm text-red-700 dark:text-red-300" }

import { ref, computed } from 'vue'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import BaseInput from '@/components/common/BaseInput.vue'
import { useToastService } from '@/services/toast'
import { employeeService } from '@/services/user'
import { AlertTriangle, RefreshCw } from 'lucide-vue-next'

const accessStartYear = 2025

export default /*@__PURE__*/_defineComponent({
  __name: 'SyncModuleAccess',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const toast = useToastService()
const currentYear = new Date().getFullYear()
const selectedYear = ref<number>(accessStartYear)
const isSyncing = ref(false)
const errorMessage = ref('')

const yearOptions = computed(() => {
	const options = []
	for (let year = accessStartYear; year <= currentYear + 10; year++) {
		options.push({ value: year, label: String(year) })
	}
	return options
})

const closeModal = () => {
	if (isSyncing.value) return
	errorMessage.value = ''
	selectedYear.value = accessStartYear
	emit('close')
}

const handleSync = async () => {
	if (isSyncing.value) return

	isSyncing.value = true
	errorMessage.value = ''

	try {
		const result = await employeeService.syncModuleAccess(Number(selectedYear.value))
		toast.success('Sync Completed', result.message)
		emit('success', result.message)
		emit('close')
	} catch (error: any) {
		const message = error?.response?.data?.message || error?.message || 'Failed to sync module access.'
		errorMessage.value = message
		toast.error('Sync Failed', message)
	} finally {
		isSyncing.value = false
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: "Sync Module Access",
    subtitle: "Reset and re-assign 44-month module access for all employees",
    icon: _unref(RefreshCw),
    size: "lg",
    type: "warning",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createVNode(BaseButton, {
        text: "Cancel",
        variant: "secondary",
        disabled: isSyncing.value,
        onClick: closeModal
      }, null, 8, ["disabled"]),
      _createVNode(BaseButton, {
        text: isSyncing.value ? 'Syncing...' : 'Sync Access',
        variant: "warning",
        icon: _unref(RefreshCw),
        loading: isSyncing.value,
        disabled: isSyncing.value,
        onClick: handleSync
      }, null, 8, ["text", "icon", "loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(AlertTriangle), { class: "h-5 w-5 text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0" }),
            _cache[1] || (_cache[1] = _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "text-sm font-semibold text-amber-800 dark:text-amber-200" }, "Important"),
              _createElementVNode("p", { class: "text-sm text-amber-700 dark:text-amber-300 mt-1" }, " This will remove current module-access assignments for active and inactive employees, then recreate access from January of the selected year for a full 44-month cycle. ")
            ], -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(BaseInput, {
            modelValue: selectedYear.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedYear).value = $event)),
            label: "Start Year",
            type: "select",
            options: yearOptions.value,
            required: true,
            "helper-text": "Module access will start from January of the selected year."
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900 dark:text-white mb-3" }, "What happens after sync", -1)),
          _createElementVNode("ul", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("li", null, "Existing module-access month assignments are cleared.", -1)),
            _createElementVNode("li", null, "Employees receive rebuilt assignments for the 44-month sequence starting January " + _toDisplayString(selectedYear.value) + ".", 1),
            _cache[3] || (_cache[3] = _createElementVNode("li", null, "Your employee list will refresh after success.", -1))
          ])
        ]),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(errorMessage.value), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["is-visible", "icon"]))
}
}

})